import React, { forwardRef } from 'react';
import classnames from 'classnames';

// @ts-ignore
import styles from './Input.scss';

/**
 * 責務: inputの表示
 * @param { InputHTMLAttributes<HtmlInputElement> } inputProps reactがデフォルトで定義しているinputのprops
 * @param { boolean } isError 入力エラーフラグ
 * @param { Ref<HTMLInputElement> } ref ref
 * @returns { JSX.Element } inputコンポーネントを返す
 */

export type InputProps = JSX.IntrinsicElements['input'] & {
  isError?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ type = 'text', isError = false, className, ...props }, ref) => {
    const classNames = isError ? [styles.input, styles.invalid] : [styles.input];

    return <input ref={ref} type={type} className={classnames(classNames, className)} {...props} />;
  },
);
